package com.imobly.imobly.ui.theme.colors

import androidx.compose.ui.graphics.Color

val PrimaryColor = Color(0xFFE35336)
val SecondaryColor = Color(0xFFE35336)
val TitleColor = Color(0xFF595959)
val ConfirmColor = Color(0xFF5FAC65)
val CancelColor = Color(0xFFE64256)
val IconColor = Color(0xFFFFFFFF)
val BackGroundColor = Color(0xFFFFFFFF)

val ReadOnlyColor = Color(0xFF545454)